
  /* 本文件未 autoview.js 自动生成  执行 npm run dir*/
	export default [

{
          path: '/apply/advance',
          name: 'applyAdvance', 
          component: () => import('@/view/apply/advance.vue'),
        },
{
          path: '/apply/allRisk',
          name: 'applyAllrisk', 
          component: () => import('@/view/apply/allRisk.vue'),
        },
{
          path: '/apply/bidding',
          name: 'applyBidding', 
          component: () => import('@/view/apply/bidding.vue'),
        },
{
          path: '/apply/bidSecurity',
          name: 'applyBidsecurity', 
          component: () => import('@/view/apply/bidSecurity.vue'),
        },
{
          path: '/apply/carRisk',
          name: 'applyCarrisk', 
          component: () => import('@/view/apply/carRisk.vue'),
        },
{
          path: '/apply/contract',
          name: 'applyContract', 
          component: () => import('@/view/apply/contract.vue'),
        },
{
          path: '/apply/cultural',
          name: 'applyCultural', 
          component: () => import('@/view/apply/cultural.vue'),
        },
{
          path: '/apply/customs',
          name: 'applyCustoms', 
          component: () => import('@/view/apply/customs.vue'),
        },
{
          path: '/apply/govAdvance',
          name: 'applyGovadvance', 
          component: () => import('@/view/apply/govAdvance.vue'),
        },
{
          path: '/apply/govBidSecurity',
          name: 'applyGovbidsecurity', 
          component: () => import('@/view/apply/govBidSecurity.vue'),
        },
{
          path: '/apply/govContract',
          name: 'applyGovcontract', 
          component: () => import('@/view/apply/govContract.vue'),
        },
{
          path: '/apply/index',
          name: 'applyIndex', 
          component: () => import('@/view/apply/index.vue'),
        },
{
          path: '/apply/lawsuit',
          name: 'applyLawsuit', 
          component: () => import('@/view/apply/lawsuit.vue'),
        },
{
          path: '/apply/owner',
          name: 'applyOwner', 
          component: () => import('@/view/apply/owner.vue'),
        },
{
          path: '/apply/peasant',
          name: 'applyPeasant', 
          component: () => import('@/view/apply/peasant.vue'),
        },
{
          path: '/apply/quality',
          name: 'applyQuality', 
          component: () => import('@/view/apply/quality.vue'),
        },
{
          path: '/apply/teamRisk',
          name: 'applyTeamrisk', 
          component: () => import('@/view/apply/teamRisk.vue'),
        },
{
          path: '/bill/index',
          name: 'billIndex', 
          component: () => import('@/view/bill/index.vue'),
        },
{
          path: '/billOrder/businessList',
          name: 'billOrderBusinesslist', 
          component: () => import('@/view/billOrder/businessList.vue'),
        },
{
          path: '/billOrder/detail',
          name: 'billOrderDetail', 
          component: () => import('@/view/billOrder/detail.vue'),
        },
{
          path: '/billOrder/list',
          name: 'billOrderList', 
          component: () => import('@/view/billOrder/list.vue'),
        },
{
          path: '/coupon/index',
          name: 'couponIndex', 
          component: () => import('@/view/coupon/index.vue'),
        },
{
          path: '/customPage/home',
          name: 'customPageHome', 
          component: () => import('@/view/customPage/home.vue'),
        },
{
          path: '/customPage/paperGuarantee/guarantee',
          name: 'customPagePaperguaranteeGuarantee', 
          component: () => import('@/view/customPage/paperGuarantee/guarantee.vue'),
        },
{
          path: '/customPage/paperGuarantee/verify',
          name: 'customPagePaperguaranteeVerify', 
          component: () => import('@/view/customPage/paperGuarantee/verify.vue'),
        },
{
          path: '/documents/civilComplaint/caseType',
          name: 'documentsCivilcomplaintCasetype', 
          component: () => import('@/view/documents/civilComplaint/caseType.vue'),
        },
{
          path: '/documents/civilComplaint/complete',
          name: 'documentsCivilcomplaintComplete', 
          component: () => import('@/view/documents/civilComplaint/complete.vue'),
        },
{
          path: '/documents/civilComplaint/confirm',
          name: 'documentsCivilcomplaintConfirm', 
          component: () => import('@/view/documents/civilComplaint/confirm.vue'),
        },
{
          path: '/documents/civilComplaint/description',
          name: 'documentsCivilcomplaintDescription', 
          component: () => import('@/view/documents/civilComplaint/description.vue'),
        },
{
          path: '/documents/civilComplaint/generated',
          name: 'documentsCivilcomplaintGenerated', 
          component: () => import('@/view/documents/civilComplaint/generated.vue'),
        },
{
          path: '/documents/civilComplaint/index',
          name: 'documentsCivilcomplaintIndex', 
          component: () => import('@/view/documents/civilComplaint/index.vue'),
        },
{
          path: '/documents/components/apply-dialog',
          name: 'documentsComponentsApply-dialog', 
          component: () => import('@/view/documents/components/apply-dialog.vue'),
        },
{
          path: '/documents/components/construction-form',
          name: 'documentsComponentsConstruction-form', 
          component: () => import('@/view/documents/components/construction-form.vue'),
        },
{
          path: '/documents/components/creditCard-form',
          name: 'documentsComponentsCreditcard-form', 
          component: () => import('@/view/documents/components/creditCard-form.vue'),
        },
{
          path: '/documents/components/delete-dialog',
          name: 'documentsComponentsDelete-dialog', 
          component: () => import('@/view/documents/components/delete-dialog.vue'),
        },
{
          path: '/documents/components/divorce-form',
          name: 'documentsComponentsDivorce-form', 
          component: () => import('@/view/documents/components/divorce-form.vue'),
        },
{
          path: '/documents/components/editName-dialog',
          name: 'documentsComponentsEditname-dialog', 
          component: () => import('@/view/documents/components/editName-dialog.vue'),
        },
{
          path: '/documents/components/financeLease-form',
          name: 'documentsComponentsFinancelease-form', 
          component: () => import('@/view/documents/components/financeLease-form.vue'),
        },
{
          path: '/documents/components/financeLoan-form',
          name: 'documentsComponentsFinanceloan-form', 
          component: () => import('@/view/documents/components/financeLoan-form.vue'),
        },
{
          path: '/documents/components/houseLease-form',
          name: 'documentsComponentsHouselease-form', 
          component: () => import('@/view/documents/components/houseLease-form.vue'),
        },
{
          path: '/documents/components/houseSale-form',
          name: 'documentsComponentsHousesale-form', 
          component: () => import('@/view/documents/components/houseSale-form.vue'),
        },
{
          path: '/documents/components/laborDispute-form',
          name: 'documentsComponentsLabordispute-form', 
          component: () => import('@/view/documents/components/laborDispute-form.vue'),
        },
{
          path: '/documents/components/liabilityInsurance-form',
          name: 'documentsComponentsLiabilityinsurance-form', 
          component: () => import('@/view/documents/components/liabilityInsurance-form.vue'),
        },
{
          path: '/documents/components/noSign-dialog',
          name: 'documentsComponentsNosign-dialog', 
          component: () => import('@/view/documents/components/noSign-dialog.vue'),
        },
{
          path: '/documents/components/personalInsurance-form',
          name: 'documentsComponentsPersonalinsurance-form', 
          component: () => import('@/view/documents/components/personalInsurance-form.vue'),
        },
{
          path: '/documents/components/privateLoan-form',
          name: 'documentsComponentsPrivateloan-form', 
          component: () => import('@/view/documents/components/privateLoan-form.vue'),
        },
{
          path: '/documents/components/propertyLossInsurance-form',
          name: 'documentsComponentsPropertylossinsurance-form', 
          component: () => import('@/view/documents/components/propertyLossInsurance-form.vue'),
        },
{
          path: '/documents/components/propertyService-form',
          name: 'documentsComponentsPropertyservice-form', 
          component: () => import('@/view/documents/components/propertyService-form.vue'),
        },
{
          path: '/documents/components/salesContract-form',
          name: 'documentsComponentsSalescontract-form', 
          component: () => import('@/view/documents/components/salesContract-form.vue'),
        },
{
          path: '/documents/components/securitiesMisrepresentation-form',
          name: 'documentsComponentsSecuritiesmisrepresentation-form', 
          component: () => import('@/view/documents/components/securitiesMisrepresentation-form.vue'),
        },
{
          path: '/documents/components/sign-dialog',
          name: 'documentsComponentsSign-dialog', 
          component: () => import('@/view/documents/components/sign-dialog.vue'),
        },
{
          path: '/documents/components/suretyInsurance-form',
          name: 'documentsComponentsSuretyinsurance-form', 
          component: () => import('@/view/documents/components/suretyInsurance-form.vue'),
        },
{
          path: '/documents/components/trafficAccident-form',
          name: 'documentsComponentsTrafficaccident-form', 
          component: () => import('@/view/documents/components/trafficAccident-form.vue'),
        },
{
          path: '/documents/index',
          name: 'documentsIndex', 
          component: () => import('@/view/documents/index.vue'),
        },
{
          path: '/documents/preservation/caseType',
          name: 'documentsPreservationCasetype', 
          component: () => import('@/view/documents/preservation/caseType.vue'),
        },
{
          path: '/documents/preservation/complete',
          name: 'documentsPreservationComplete', 
          component: () => import('@/view/documents/preservation/complete.vue'),
        },
{
          path: '/documents/preservation/confirm',
          name: 'documentsPreservationConfirm', 
          component: () => import('@/view/documents/preservation/confirm.vue'),
        },
{
          path: '/documents/preservation/description',
          name: 'documentsPreservationDescription', 
          component: () => import('@/view/documents/preservation/description.vue'),
        },
{
          path: '/documents/preservation/generated',
          name: 'documentsPreservationGenerated', 
          component: () => import('@/view/documents/preservation/generated.vue'),
        },
{
          path: '/documents/preservation/index',
          name: 'documentsPreservationIndex', 
          component: () => import('@/view/documents/preservation/index.vue'),
        },
{
          path: '/documents/records/index',
          name: 'documentsRecordsIndex', 
          component: () => import('@/view/documents/records/index.vue'),
        },
{
          path: '/documents/templates/index',
          name: 'documentsTemplatesIndex', 
          component: () => import('@/view/documents/templates/index.vue'),
        },
{
          path: '/invoice/detail',
          name: 'invoiceDetail', 
          component: () => import('@/view/invoice/detail.vue'),
        },
{
          path: '/invoice/list',
          name: 'invoiceList', 
          component: () => import('@/view/invoice/list.vue'),
        },
{
          path: '/loan/apply',
          name: 'loanApply', 
          component: () => import('@/view/loan/apply.vue'),
        },
{
          path: '/loan/components/loanTabScroll',
          name: 'loanComponentsLoantabscroll', 
          component: () => import('@/view/loan/components/loanTabScroll.vue'),
        },
{
          path: '/loan/components/titleScroll',
          name: 'loanComponentsTitlescroll', 
          component: () => import('@/view/loan/components/titleScroll.vue'),
        },
{
          path: '/loan/institutionList',
          name: 'loanInstitutionlist', 
          component: () => import('@/view/loan/institutionList.vue'),
        },
{
          path: '/loan/order',
          name: 'loanOrder', 
          component: () => import('@/view/loan/order.vue'),
        },
{
          path: '/notify/list',
          name: 'notifyList', 
          component: () => import('@/view/notify/list.vue'),
        },
{
          path: '/order/advance/list',
          name: 'orderAdvanceList', 
          component: () => import('@/view/order/advance/list.vue'),
        },
{
          path: '/order/allRisk/list',
          name: 'orderAllriskList', 
          component: () => import('@/view/order/allRisk/list.vue'),
        },
{
          path: '/order/bidding/list',
          name: 'orderBiddingList', 
          component: () => import('@/view/order/bidding/list.vue'),
        },
{
          path: '/order/bidSecurity/list',
          name: 'orderBidsecurityList', 
          component: () => import('@/view/order/bidSecurity/list.vue'),
        },
{
          path: '/order/carRisk/list',
          name: 'orderCarriskList', 
          component: () => import('@/view/order/carRisk/list.vue'),
        },
{
          path: '/order/contract/list',
          name: 'orderContractList', 
          component: () => import('@/view/order/contract/list.vue'),
        },
{
          path: '/order/cultural/list',
          name: 'orderCulturalList', 
          component: () => import('@/view/order/cultural/list.vue'),
        },
{
          path: '/order/customs/list',
          name: 'orderCustomsList', 
          component: () => import('@/view/order/customs/list.vue'),
        },
{
          path: '/order/govAdvance/list',
          name: 'orderGovadvanceList', 
          component: () => import('@/view/order/govAdvance/list.vue'),
        },
{
          path: '/order/govBidSecurity/list',
          name: 'orderGovbidsecurityList', 
          component: () => import('@/view/order/govBidSecurity/list.vue'),
        },
{
          path: '/order/govContract/list',
          name: 'orderGovcontractList', 
          component: () => import('@/view/order/govContract/list.vue'),
        },
{
          path: '/order/index',
          name: 'orderIndex', 
          component: () => import('@/view/order/index.vue'),
        },
{
          path: '/order/lawsuit/list',
          name: 'orderLawsuitList', 
          component: () => import('@/view/order/lawsuit/list.vue'),
        },
{
          path: '/order/owner/list',
          name: 'orderOwnerList', 
          component: () => import('@/view/order/owner/list.vue'),
        },
{
          path: '/order/peasant/list',
          name: 'orderPeasantList', 
          component: () => import('@/view/order/peasant/list.vue'),
        },
{
          path: '/order/quality/list',
          name: 'orderQualityList', 
          component: () => import('@/view/order/quality/list.vue'),
        },
{
          path: '/order/safe/list',
          name: 'orderSafeList', 
          component: () => import('@/view/order/safe/list.vue'),
        },
{
          path: '/order/teamRisk/list',
          name: 'orderTeamriskList', 
          component: () => import('@/view/order/teamRisk/list.vue'),
        },
{
          path: '/paperGuarantee/index',
          name: 'paperGuaranteeIndex', 
          component: () => import('@/view/paperGuarantee/index.vue'),
        },
{
          path: '/points/components/details',
          name: 'pointsComponentsDetails', 
          component: () => import('@/view/points/components/details.vue'),
        },
{
          path: '/points/components/records',
          name: 'pointsComponentsRecords', 
          component: () => import('@/view/points/components/records.vue'),
        },
{
          path: '/points/detail',
          name: 'pointsDetail', 
          component: () => import('@/view/points/detail.vue'),
        },
{
          path: '/points/index',
          name: 'pointsIndex', 
          component: () => import('@/view/points/index.vue'),
        },
{
          path: '/points/mine',
          name: 'pointsMine', 
          component: () => import('@/view/points/mine.vue'),
        },
{
          path: '/projectList/bidSecurity',
          name: 'projectListBidsecurity', 
          component: () => import('@/view/projectList/bidSecurity.vue'),
        },
{
          path: '/projectList/govBidSecurity',
          name: 'projectListGovbidsecurity', 
          component: () => import('@/view/projectList/govBidSecurity.vue'),
        },
{
          path: '/protocol/register',
          name: 'protocolRegister', 
          component: () => import('@/view/protocol/register.vue'),
        },
{
          path: '/user/account/info',
          name: 'userAccountInfo', 
          component: () => import('@/view/user/account/info.vue'),
        },
{
          path: '/user/account/modifyPasw',
          name: 'userAccountModifypasw', 
          component: () => import('@/view/user/account/modifyPasw.vue'),
        },
{
          path: '/user/ca',
          name: 'userCa', 
          component: () => import('@/view/user/ca.vue'),
        },
{
          path: '/user/company/edit',
          name: 'userCompanyEdit', 
          component: () => import('@/view/user/company/edit.vue'),
        },
{
          path: '/user/company/info',
          name: 'userCompanyInfo', 
          component: () => import('@/view/user/company/info.vue'),
        },
{
          path: '/user/qualifications/edit',
          name: 'userQualificationsEdit', 
          component: () => import('@/view/user/qualifications/edit.vue'),
        },
{
          path: '/user/qualifications/list',
          name: 'userQualificationsList', 
          component: () => import('@/view/user/qualifications/list.vue'),
        },
]